import CategoryDropdown from "@/components/feature/CategoryDropdown";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Artistic%20fashion%20collage%20with%20textured%20fabric%20swatches%20in%20warm%20terracotta%20sand%20and%20cream%20tones%20arranged%20on%20a%20minimal%20surface%2C%20soft%20diffused%20natural%20lighting%2C%20abstract%20editorial%20composition%2C%20elegant%20earthy%20aesthetic%2C%20high%20detail%2C%20no%20people%2C%20harmonious%20warm%20palette&width=1800&height=900&seq=hero-main-v2-2025&orientation=landscape"
        alt="Artistic fashion textile collage with warm earthy tones"
        title="Pandabuy Sheet - Your Ultimate Fashion Spreadsheet Hub"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/60"></div>

      <div className="relative z-10 w-full px-6 md:px-10">
        <div className="max-w-3xl">
          <div className="mb-6">
            <CategoryDropdown />
          </div>
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-white leading-tight mb-5">
            Your Ultimate<br />
            Pandabuy Fashion<br />
            Spreadsheet
          </h1>
          <p className="text-base md:text-lg text-white/80 max-w-xl mb-8 leading-relaxed">
            Discover curated fashion spreadsheets, outfit breakdowns, and price comparison tables updated weekly. Find better style choices in seconds across 14 product categories.
          </p>
          <div className="flex flex-col sm:flex-row items-start gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-7 py-3 rounded-full bg-primary-500 text-background-50 text-sm md:text-base font-medium whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
            >
              Pandabuy Sheet
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-7 py-3 rounded-full border border-white/40 text-white text-sm md:text-base font-medium whitespace-nowrap cursor-pointer hover:bg-white/10 transition-colors"
            >
              Buy It Now
            </a>
          </div>
        </div>

        <div className="mt-12 md:mt-16 flex flex-wrap gap-6 md:gap-10">
          <div className="text-white/80">
            <p className="text-2xl md:text-3xl font-heading font-bold text-white">1,000+</p>
            <p className="text-xs md:text-sm text-white/60 mt-1">Curated Items</p>
          </div>
          <div className="text-white/80">
            <p className="text-2xl md:text-3xl font-heading font-bold text-white">14</p>
            <p className="text-xs md:text-sm text-white/60 mt-1">Categories</p>
          </div>
          <div className="text-white/80">
            <p className="text-2xl md:text-3xl font-heading font-bold text-white">Weekly</p>
            <p className="text-xs md:text-sm text-white/60 mt-1">Updates</p>
          </div>
          <div className="text-white/80">
            <p className="text-2xl md:text-3xl font-heading font-bold text-white">Free</p>
            <p className="text-xs md:text-sm text-white/60 mt-1">Access</p>
          </div>
        </div>
      </div>
    </section>
  );
}